<template>
  <div class="MaintainDemo">
    <div class="formText">
      <p v-for="(item, index) in info.content"
         :key="index" class="clearfix">
        <span class="lable">{{item.title}}</span>
        <span class="content"  v-if="item.type !== 7">{{item.value}}</span>
        <van-swipe class="img_b" :autoplay="2000" v-if="item.type === 7">
          <van-swipe-item v-for="(image, index) in getImgUrl(item.value)" :key="index">
            <img class="img_b" v-lazy="image" @click="showImg(item.value, index)"/>
          </van-swipe-item>
        </van-swipe>
      </p>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant';

export default {
  props: {
    info:{
      type: Object,
      default() {
        return{};
      },
    },
  },
  methods: {
    getImgUrl(value) {
      return typeof value === 'string' ? value.split(',') : [];
    },
    showImg(value, k) {
      let arrUrl = this.getImgUrl(value);
      ImagePreview(arrUrl, k);
    },
  },
}
</script>
<style lang="scss" scoped>
.formText{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 1px solid rgb(245, 245, 245);
  padding: 0 .32rem;
  p{
    min-height: 1.173333rem;
    border-bottom: 1px solid rgb(245, 245, 245);
    display: flex;
    align-items: center;
    padding: .066667rem 0;
  }
  .lable{
    width: 3.173333rem;
    text-align: left;
    flex-shrink: 0;
  }
  .content {
    flex: 1;
  }
  .img_b{
    width: 4rem;
    height: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/orderComponents/MaintainDemo.vue